import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import type { MatchedTradingPhotoCardType } from '../types/MarketCardType';
import ExchangePhotoCardItem from './ExchangePhotoCardItem';

interface ExchangePhotoCardItemListProps {
  filteredPhotoCards: MatchedTradingPhotoCardType[];
}

const ExchangePhotoCardItemList = ({ filteredPhotoCards }: ExchangePhotoCardItemListProps) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/tradings/photo_cards');
  };

  if (filteredPhotoCards.length === 0) {
    return (
      <div className="flex flex-col items-center mt-[128px] leading-none">
        <p className="h-[75px] flex items-center text-[50px]">😳</p>
        <p className="text-text-main-lv2 text-[17px] font-bold mt-[8px]">
          {t('NewTradingPhotoCardMarket.noPhotoCard', {
            category: t('NewTradingPhotoCardMarket.notifications.messageCategoryExchanging')
          })}
        </p>
        <button
          type="button"
          className="mt-[38px] px-[18px] py-[11px] text-[14px] font-semibold text-text-main-lv2 border border-surface-lv2 bg-surface-lv1 rounded-[52px]"
          onClick={handleNavigate}
        >
          {t('NewTradingPhotoCardMarket.goToExchange')}
        </button>
      </div>
    );
  }

  return filteredPhotoCards.map((photoCard) => (
    <ExchangePhotoCardItem key={photoCard.matchedTradingPhotoCardId} photoCard={photoCard} />
  ));
};

export default ExchangePhotoCardItemList;
